export default {"src":"/_next/static/media/arrowDown.bd9be040.svg","height":7,"width":12,"blurWidth":0,"blurHeight":0};